import { cx } from "@/components/ui/cx"
import { clockStamp } from "@/lib/duration"
import type { TimelineEntry } from "@/pages/admin/calls/types"

/*
 * The session's history — events, commands and transitions interleaved, as
 * `Trumpet::Voice.timeline` returns them, in the instrument's voice. The
 * memo-callback path (memo_prompting → redialing_staffer → memo_prompting) is
 * drawn in print so the recovery is visible at a glance.
 */
export function Timeline({ entries }: { entries: TimelineEntry[] }) {
  if (entries.length === 0) {
    return <p className="text-tertiary text-sm">No history recorded yet.</p>
  }
  return (
    <ol className="flex flex-col gap-1">
      {entries.map((e, i) => (
        <li
          key={e.seq ?? i}
          className={cx(
            "grid grid-cols-[auto_minmax(0,1fr)] items-baseline gap-x-3 text-sm",
            e.recovery ? "text-brand-secondary" : "text-secondary",
            e.kind !== "transition" && !e.recovery && "text-tertiary",
          )}
        >
          <span className="notation">{clockStamp(e.at)}</span>
          <span className="min-w-0">
            {e.text}
            {e.to_state && (
              <span
                className={cx(
                  "notation ml-2",
                  e.recovery && "text-brand-secondary",
                )}
              >
                → {e.to_state}
              </span>
            )}
          </span>
        </li>
      ))}
    </ol>
  )
}
